import { Injectable } from '@angular/core';
import { ApiResponse, Supplier } from "app/entities";
import { ApiService } from "app/services/api.service";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SuppliersService extends ApiService {

    findAll(params: any) {
        params = this.paramsFromObject(params);
        params.summed_up = false;
        return this.httpService.get(`/v1/clients/suppliers`, params)
            .pipe(
                map(res => ApiResponse.parseWith(new Supplier, res) as ApiResponse<Supplier[]>)
            );
    }

    store(data: any) {
        let formData = this.formDataFromObject(data);
        return this.httpService.post(`/v1/clients/suppliers`, formData)
            .pipe(
                map(res => Supplier.parse(res.data) as Supplier)
            );
    }

    update(supplierId: number, data: any) {
        let formData = this.formDataFromObject(data);
        return this.httpService.post(`/v1/clients/suppliers/${supplierId}`, formData)
            .pipe(
                map(res => Supplier.parse(res.data) as Supplier)
            );
    }

    destroy(id: number) {
        return this.httpService.delete(`/v1/clients/suppliers/${id}/delete`);
    }

    find(id: any) {
        return this.httpService.get(`/v1/clients/suppliers/${id}`)
            .pipe(
                map(res => Supplier.parse(res.data) as Supplier)
            );
    }
}
